import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Filter } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/badge";

type Props = {
  children: React.ReactNode;
  countFilters: number;
};

const MapFiltersWrapper: React.FC<Props> = ({ children, countFilters }) => {
  const t = useTranslations("map");
  return (
    <div className="google-anno-skip absolute left-2 top-2 z-50">
      <Sheet>
        <SheetTrigger asChild>
          <Button
            variant="outline"
            className="h-11 border-border/80 bg-white/95 shadow-sm backdrop-blur hover:bg-white"
          >
            <Filter className={twMerge("w-6 h-6")} />
            <span>{t("filter-search")}</span>
            {countFilters > 0 && (
              <Badge variant="secondary">
                <span>{countFilters}</span>
              </Badge>
            )}
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="overflow-y-auto scrollbar-none">
          <SheetHeader className="sr-only">
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          {children}
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MapFiltersWrapper;
